import AlertMsgModalView from './AlertMsgModal.view';
export default AlertMsgModalView;
